import { Component, OnInit } from '@angular/core';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzDividerModule } from 'ng-zorro-antd/divider';

import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { HttpService } from '../../services/http.service';
import { ConsultTypeService } from '../../services/consult-type.service';
import { UserAccountDTO } from '../../classes/user-account.dto';
import { StorageService } from '../../services/storage.service';

@Component({
  selector: 'app-medical-consultations-details',
  imports: [NzCardModule, NzGridModule, NzDividerModule, NzIconModule, NzCollapseModule, NzBadgeModule, TranslateModule, RouterLink],
  templateUrl: './medical-consultations-details.component.html',
  styleUrl: './medical-consultations-details.component.scss',
})
export class MedicalConsultationsDetailsComponent implements OnInit {
  values!: [string];
  isPathway: boolean = false;
  details: any;
  payment: any;
  backLink: string[] = ['../..'];

  constructor(
    private translateService: TranslateService,
    private route: ActivatedRoute,
    private http: HttpService,
    private router: Router,
    private consultTypeService: ConsultTypeService,
    private storage: StorageService
  ) {
    this.translateService.get('medicalConsultationsDetail.values').subscribe((values): void => {
      this.values = values;
    });
  }

  ngOnInit() {
    const currentUrl = this.router.url;
    if (currentUrl.includes('personal-area/payment-details/')) {
      this.backLink = ['/personal-area/invoices-and-methods-payment'];
    }
    this.route.paramMap.subscribe((params) => {
      const appointmentId = params.get('id');
      const rateNumber = params.get('rateNumber');
      if (appointmentId) {
        this.http.getConsultRequestDetail(appointmentId).subscribe((res: any) => (this.details = res));
      } else if (rateNumber) {
        this.http.getPaymentDetails(rateNumber).subscribe((res) => {
          this.payment = res;
        });
      }
      this.checkPathway();
    });
  }

  getBadgeStatus(status: string): string {
    console.log(status);
    switch (status) {
      case 'Confirmed':
      case 'CompletedWritten':
      case 'CompletedVideo':
      case 'CompletedPhone':
      case 'Televisit':
      case 'PAGATO':
        return 'success';
      case 'Canceled':
      case 'CustomerNotAvailable':
      case 'Rejected':
      case 'SupplementaryDocumentationNeeded':
      case 'VideoCallProblemConnection':
      case 'CallDandledByJunoOperator':
      case 'ANNULLATO':
        return 'error';
      case 'ReadyToAssist':
      case 'Awaiting':
      case 'DocumentsProvided':
      case 'NewProposals':
      case 'SaveNpsData':
      case 'IN_ATTESA':
      default:
        return 'warning';
    }
  }

  getBadgeBackground(status: string): any {
    let string = 'background-color: ';
    switch (status) {
      case 'Confirmed':
      case 'CompletedWritten':
      case 'CompletedVideo':
      case 'CompletedPhone':
      case 'Televisit':
      case 'PAGATO':
        return string + '#E5F2EB;' + 'border: 1px solid #219653';
      case 'Canceled':
      case 'CustomerNotAvailable':
      case 'Rejected':
      case 'SupplementaryDocumentationNeeded':
      case 'VideoCallProblemConnection':
      case 'CallDandledByJunoOperator':
      case 'ANNULLATO':
        return string + '#F8E0E5;' + 'border: 1px solid #C80226';
      case 'ReadyToAssist':
      case 'Awaiting':
      case 'DocumentsProvided':
      case 'NewProposals':
      case 'SaveNpsData':
      case 'IN_ATTESA':
      default:
        return string + '#FDF8E9;' + 'border: 1px solid #F2C94C';
    }
  }

  downloadFile(doc: any): void {
    const userData = JSON.parse(this.storage.getItem('userData')!) as UserAccountDTO;
    const individualId = userData?.individualId;
    this.http.downloadSingleDocument(individualId, doc.documentName, true).subscribe((urlObj: { docUrl: string }) => {
      const link = document.createElement('a');
      link.href = urlObj.docUrl;
      link.download = doc.docName;
      link.click();
    });
  }

  private checkPathway() {
    if (this.details) {
      const consultType = this.details.consultType;
      if ((consultType === 'TreatmentPathPsiTelevisitFU' || consultType === 'TreatmentPathNutTelevisitFU') && this.details.appointments.length > 1) {
        this.isPathway = true;
      }
    }
  }

  public formatAppointmentStartDateDocuments(dateString: string): string {
    const months = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];
    const date = new Date(dateString);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  }

  public formatDateDocuments(dataString: string): string {
    const months = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];
    const [date, hour] = dataString.split(' ');
    const [day, month, year] = date.split('/').map(Number);
    const [hours, minutes] = hour.split('.').map(Number);
    const parsedDate = new Date(year, month - 1, day, hours, minutes);

    const nameMonth = months[parsedDate.getMonth()];
    return `${parsedDate.getDate()} ${nameMonth} ${parsedDate.getFullYear()} ${parsedDate.getHours().toString().padStart(2, '0')}:${parsedDate.getMinutes().toString().padStart(2, '0')}`;
  }

  public parseCustomDate(dateString: any) {
    if (dateString) {
      const dateSplitted = dateString.split('T')[0];
      return dateSplitted.replaceAll('-', '/');
    }
    return '-';
  }

  getType(consultType: string): string {
    return this.consultTypeService.getTipologia(consultType);
  }

  getPrestation(consultType: string): string {
    return this.consultTypeService.getPrestazione(consultType);
  }
}
